export default {"src":"/_next/static/media/healthOutline100_40.981489f5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};